import { setDoc, doc, collection, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../lib/firebase.config";

const Firestore = {
    readProducts: (...args) => {
        const [collection_name] = args
        let docs =[]
        const ref = collection(db, "products")
        return new Promise(async resolve => {
            try {
                const snapshots = await getDocs(ref)
                snapshots.forEach(doc => {
                    const d = { ...doc.data(), id: doc.id }
                    docs.push(d)
                })
                resolve(docs)
            } catch(e) {
                console.log(e);
            }
        })
    },
    createProduct: (...args) => {
        const [inputs, collection_name] = args
        return new Promise(async resolve => {
            try {
                const docRef = doc(collection(db, 'products'));
                await setDoc(docRef, { 
                    title: inputs.title, 
                    category: inputs.category, 
                    subcategory: inputs.subcategory, 
                    gender: inputs.gender, 
                    description: inputs.description, 
                    price: inputs.price, 
                    size: inputs.size, 
                    quantity: inputs.quantity, 
                    color: inputs.color, 
                    status: inputs.status || 'Available', 
                    path: inputs.path, 
                    likes: 0,
                    user: inputs.user
                });
                resolve('new doc successfully inserted');
            } catch(e) {
                console.error("Error creating new document:", e);
            }
        });
    },
    updateProduct: (...args) => {
        const [inputs, collection_name, itemId] = args; // Extracting inputs and product ID
        return new Promise(async (resolve, reject) => {
            try {
                const docRef = doc(db, 'products', itemId); // Provide the document ID
                await updateDoc(docRef, { 
                    title: inputs.title, 
                    category: inputs.category, 
                    subcategory: inputs.subcategory, 
                    gender: inputs.gender, 
                    description: inputs.description, 
                    price: inputs.price, 
                    size: inputs.size, 
                    quantity: inputs.quantity, 
                    color: inputs.color,  
                    path: inputs.path, 
                    user: inputs.user
                });
                resolve('Document successfully updated');
            } catch(e) {
                console.error("Error updating document:", e);
                reject(e);
            }
        });
    }   
}
export default Firestore
